import { Grid } from '@material-ui/core'

import useStyles from './styles'

const ContentWithOutSubTabs = (props) => {
  const { children } = props
  const classes = useStyles()

  return (
    <div>
      <Grid container>
        <Grid item sm={12} xs={12} className={classes.gridScroll}>
          {children}
        </Grid>
      </Grid>
    </div>
  )
}
export default ContentWithOutSubTabs
